(function() {
  'use strict';

  function FAQController(
    FAQs,
    Auth,
    Utils,
    Notify,
    RouterHelper // Replaced Router with RouterHelper
  ) {
    // This controller can be used both with ui-router and Angular router
    var ctrl = this;

    // Fields the backend accepts for FAQ documents
    var FAQ_EDITABLE_FIELDS = [
      'question', 'answer', 'dates'
    ];

    ctrl.faq = {};
    ctrl.loaded = false;

    ctrl.$onInit = function() {
      var faqId = ctrl.faqId;
      if (faqId && faqId !== 'new') {
        FAQs.find(faqId)
          .then(function(data) {
            ctrl.faq = data;
            Utils.setPageTitle('Edit frequently asked question: ' + ctrl.faq.question);
            ctrl.showDelete = true;
            ctrl.loaded = true;
          })
          .catch(function(err) {
            Utils.showError(err);
            ctrl.loaded = true;
          });
      } else {
        Utils.setPageTitle('New frequently asked question');
        // this is a new faq Type, let's make sure it gets an ID
        ctrl.faq._id = Utils.guid();
        ctrl.faq.organisation = Auth.currentOrganisation();
        ctrl.loaded = true;
      }
    };

    ctrl.save = function(isValid) {
      ctrl.formIsSubmitted = true;
      if (isValid) {
        var actionName = 'modified';
        var isNew = ctrl.faq._rev === undefined;
        if (isNew) {
          actionName = 'created';
        }

        Utils.recordLog(ctrl.faq, actionName, Auth.currentUser());
        ctrl.faq.type = 'faq'; // Make sure this is faq and not something else

        var payload = Utils.buildPayload(ctrl.faq, FAQ_EDITABLE_FIELDS);

        FAQs.save(payload)
          .then(function(data) {
            ctrl.faq._rev = data._rev;
            ctrl.formIsSaved = true;
            Notify.success('FAQ successfully saved!', 'Success');
            RouterHelper.navigate(['/faqs']);
          })
          .catch(Utils.showError);
      }
    };

    ctrl.remove = function() {
      Utils.swal({
        title: 'Are you sure you want to remove this faq?',
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK'
      }, function(isConfirm) {
        if (!isConfirm) {
          return;
        }
        FAQs.remove(ctrl.faq._id)
          .then(function() {
            Notify.success('FAQ successfully removed!', 'Success');
            RouterHelper.navigate(['/faqs']);
          })
          .catch(Utils.showError);
      });
    };

    // Helper function to navigate to the FAQs list
    function navigateToFaqsList() {
      RouterHelper.navigate(['/faqs']);
    }

    // Add cancel method for the form
    ctrl.cancel = function() {
      if (ctrl.form && ctrl.form.$dirty) {
        if (Utils.confirmDialog('You have unsaved changes. Are you sure you want to cancel?')) {
          navigateToFaqsList();
        }
      } else {
        // Navigate back to the FAQs list
        navigateToFaqsList();
      }
    };
  }

  FAQController.$inject = [
    'FAQsService',
    'AuthService',
    'UtilsService',
    'NotifyService',
    'RouterHelperService'
  ];

  angular.module('component.faqs')
    .controller('FAQController', FAQController);
})();
